<template>
    <div class="dpp-hotleadbutton" ref="hotleadbutton" :class="{ 'vertical-layout': requestVerticallLayout, 'oversize-context': oversizeContent }">
        <template v-if="dpp.isActive">
            <div v-if="hasOJOAgent" class="agent-contact flex" @click="openAssignedAgentHotlead(molang('dpp.hotButton.manageAssignedAgent'))">
                <img v-if="assignedAgent && assignedAgent.photoUrl" :title="assignedAgent.fullName"  alt="Agent Avatar" :src="assignedAgent.photoUrl" />
                <img v-else-if="getAgentImageUrl" :title="glb.agent.name"  alt="Agent Avatar" :src="getAgentImageUrl" />
                <button type="button" v-if="hasTxtMsgForAgent" @click="sendMessage(e)" class="btn primary regular w-100">{{getAssignedAgentLabel}}</button>
                <button type="button" v-else class="btn primary regular width-fixed w-100">{{getAssignedAgentLabel}}</button>
            </div>
            <template v-else>
                <template v-if="!dpp.isRentals">
                    <button type="button" v-if="preApprovalButtonObj"  class="btn secondary regular" @click="showForm(preApprovalButtonObj)">{{preApprovalButtonObj.cta}}</button>
                    <button type="button" v-else-if="!dpp.listingByMovoto && !dpp.isRDC" class="btn secondary regular"  @click="openHotlead(secondaryCtaTxt)">{{secondaryCtaTxt}} </button>
                    <button type="button" class="btn primary regular" :class="{ 'larger-font': isLargerSubtext }" :data-label="requestTourSubtext" @click="openHotlead(getCTALabel)" v-html="getCTALabel"></button>
                </template>
                <template v-else>
                    <button type="button" class="btn primary regular" @click="openHotlead('Check Availability')">Check Availability</button>
                </template>
            </template>
        </template>

        <template v-else>
            <template v-if="dpp.isRentals">
                <button type="button" class="btn primary regular" @click="openHotlead('Check Availability')">Check Availability</button>
            </template>
            <template v-else>
                <template v-if="newSoldPublicRecordCta">
                    <a v-if="isDigsSubscribed" class="btn secondary regular hidden-xs" :href="glb.appUrl + 'my-movoto/owned-homes/' + dpp.propertyId + '/'">Owner Dashboard</a>
                    <button type="button" v-else class="btn secondary regular hidden-xs" @click="openDig()">{{ molang('dpp.hotButton.iAmOwner') }}</button>
                    <button type="button" class="btn primary regular" @click="openInActiveSellLead()"> Schedule a selling consultation </button>
                </template>
                <template v-else>
                    <button type="button" v-if="showCashOffer" class="btn secondary regular" @click="openCashOffer()">Get a Cash Offer</button>
                    <button type="button" v-else class="btn secondary regular" @click="openInActiveSellLead()"> Message <span>Agent</span> </button>
                    <a v-if="isDigsSubscribed" class="btn alternative regular" :href="glb.appUrl + 'my-movoto/owned-homes/' + dpp.propertyId + '/'">Owner Dashboard</a>
                    <button type="button" v-else class="btn primary regular" @click="openDig()">{{ molang('dpp.hotButton.iAmOwner') }}</button>
                </template>
            </template>
        </template>
    </div>
    <button id="btnChangeAgent" type="button" v-if="dpp.isActive && hasOJOAgent && glb.assignedAgents.length > 1" class="link flex center" href="javascript:;" @click="openAgentSelection">
        <i class="icon-exchange"></i> Change Agent
    </button>
</template>
<script src="./dpp-hotleadbutton.js"></script>
<style lang="scss">
@use "./dpp-hotleadbutton.scss" as *;
</style>